// Harmless preferences on this device: the display name, the language and the listening
// mode. Nothing else is stored: no cookie, never a token (ADR 002).
//
// Best effort: storage can be blocked or partitioned (a frame on another site, strict privacy
// settings); then the lobby simply starts empty. The keys carry the "vm." prefix because under
// versiyonbir.com/v1-meet this app shares the site's origin, and so its localStorage.

const KEYS = {
  name: 'vm.name',
  language: 'vm.lang',
  // The listening mode, voice | subtitles | off (ADR 001, the listener rule): written by the
  // switch B-002 adds to the room.
  mode: 'vm.mode',
  // The host's copilot switch, on | off (B-023).
  copilot: 'vm.copilot',
} as const;

export type PrefKey = keyof typeof KEYS;

export function readPref(key: PrefKey): string | null {
  try {
    return window.localStorage.getItem(KEYS[key]);
  } catch {
    return null;
  }
}

export function writePref(key: PrefKey, value: string): void {
  try {
    window.localStorage.setItem(KEYS[key], value);
  } catch {
    // Storage blocked: the preference lasts for this page only.
  }
}
